import "./button.css"

const Button = ({ type, text }) => (
    <button className={"shopProductButton " + type}>{text}</button>
)

export default Button;